import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent implements OnInit {

    @Input() library: 'fontawesome' | 'material' | 'prime' = 'fontawesome';
    @Input() variant = 'fa-cog';
    @Input() text = ''
    @HostBinding('class.responsive') @Input() responsive = false;
    @HostBinding('class.inline') @Input() inline = false;
    @HostBinding('class.disabled') @Input() disabled = false;

    constructor() {
    }

    ngOnInit(): void {
    }

}
